//////// POINTS MAP EXAMPLE ///////////////////////
// export const BOUNDS_SMALL = [-118.965411, 34.285528, -117.81778, 33.72144];
export const BOUNDS_SMALL = [-118.00499, 34.494812, -118.674487, 33.6010159];
// export const BOUNDS_LARGE = [-119.25658, 34.29202, -116.841974, 33.5024226];
export const BOUNDS_LARGE = [-118.955854, 33.690791, -117.728976, 34.3198969];

// export const CENTER_SMALL = [-118.24305231430876, 34.05490617137432];
// export const CENTER_LARGE = [-118.26496, 34.05354];
// export const INITIAL_ZOOM_LEVEL = 11.95;

// REMOVE LA PARAMETERS
export const CENTER_SMALL = [-118.2917,34.0084]
export const CENTER_LARGE = [-118.4663,33.9679];
export const INITIAL_ZOOM_LEVEL = 9.15;

export const STYLE = `mapbox://styles/latimes/cliuhiyie00mv01r88kwi687s${
  process.env.NODE_ENV === 'development' ? '/draft' : ''
}`;
export const TILESET = 'mapbox://latimes.seismic-retrofit-map-2023';
export const SOURCE_LAYER = 'buildings';
export const SOURCE = 'source';
export const TOKEN =
  'pk.eyJ1IjoibGF0aW1lcyIsImEiOiJjbHAxd2dnbjIwa2M0MmlzMWx0bXJ3b3gyIn0.W-COR0Qd1ZCX6kmdlChKIQ';
